/* eslint-disable no-restricted-globals */
/* eslint-disable dot-notation */
/* eslint-disable max-len */
/* eslint-disable no-console */
import React, { createContext, useContext, useEffect, useMemo, useRef, useState } from 'react';
import { Avatar, Box, Grid, Stack, TextField, Typography, useMediaQuery } from '@mui/material';
import { VscSend } from 'react-icons/vsc';
import { RxCross2 } from 'react-icons/rx';
import { MdOutlineGif } from 'react-icons/md';
import { CgSmileMouthOpen } from 'react-icons/cg';
import EmojiPicker, { EmojiStyle } from 'emoji-picker-react';
import { LanguageContext } from '../../../../../libs/Context';
import { FaAngleUp } from 'react-icons/fa6';
import { Theme } from '@mui/material/styles';
import { useSelector } from 'react-redux';
import useInterSectionObserver from '../../../../../libs/CustomHooks/useIntersectionObserver';
import { catchErr, DateDiff, generateRandomUUID, userFullName } from '../../../../../libs/HelperContent';
import { createComment, getComments, updateCommentApi } from '../../../../actions/feeds_actions_new';
import IndividualCmnt from './Components/IndividualComments/IndividualCmnt';
import NoData from '../../../../../components/Common/NoData';
import { createEventComments, getEventComments, updateEventComment } from '../../../../actions/recognition_actions';
import { FeedActionContext, feedActionContext } from '../../..';
import ProfilePic from '../../../../../components/Common/ProfilePic';
import { useParams } from 'react-router-dom';
import GifPickerWrapper from '../../../../../components/Common/GifPicker';
import { feedActionContextFromExternal } from '../../ExternalRequest';

export const commentContext = createContext<any>({});

const Comments = (props) =>
{
	const { setOpenComment, openComment, selEvent, from } = props;

	const { type } = useParams();
	const { language } = useContext(LanguageContext);
	const { feedCardActn, setFeedCardActn, handleFeedAction, feedAction } = useContext<FeedActionContext>(window.location.pathname.includes('news') ? feedActionContext : feedActionContextFromExternal);

	const userData = useSelector((state:any) => state?.mysession?.session);

	const [ showPicker, setShowPicker ] = useState<string>();
	const [ loading, setLoading ] = useState<boolean>(false);
	const [ page, setPage ] = useState<number>(0);
	const loaderRef = useRef<any>(false);
	const lastEleRef = useRef<any>();
	const autoFocusRef = useRef<any>(null);

	const [ commntsData, setCommntsData ] = useState<any>([]);
	const [ action, setAction ] = useState<any>({});
	const [ callApi, setCallApi ] = useState<boolean>(false);
	const cmmntsCount = feedAction?.comments_add ?? 0;
	const commentsPerPage = 5;
	const actionKeys = Object?.keys(action)?.length > 0 && Object?.entries(action)[0];
	const [ comment, setComment ] = useState<any>('');

	// Pagination
	const LoadMoreList = useInterSectionObserver({ lastEleRef,
		loaderRef,
		count : cmmntsCount,
		data  : commntsData,
		setPage });

	// Comment Count
	const getCmmntsCount = async (query:any) =>
	{
		try
		{
			query.count = true;
			const path = feedCardActn[1]?._id;
			const res = from === 'events'
				? await getEventComments(query) // get event comments count
				: await getComments(path, query); // get feed comments count

			if (res?.status)
			{
				handleFeedAction('append', 'comments_add', res.count);
			}

			else
			{
				handleFeedAction('append', 'comments_add', 0);
			}
		}
		catch (err)
		{
			console.log('---------------', err);
			setLoading(false);
			catchErr(err);
		}
	};

	// Get comment list as per the from type : feeds/events
	const getCommentsList = async () =>
	{
		setLoading(page === 0);
		try
		{
			const query:any = {
				uid     : userData?.userId,
				comid   : userData?.companyId,
				empRole : userData?.empRole,
				role    : userData?.role,
				skip    : page,
				limit   : commentsPerPage
			};

			if (from === 'events')
			{
				query['eventId'] = feedCardActn[0] === 'allEventCmnt' ? feedCardActn[1]?.eventId : selEvent?.eventId;
				if ([ 2, 3, 4 ]?.includes(selEvent?.eventType))
				{
					query['startedAt'] = `${new Date()?.setHours(0, 0, 0, 0)}`;
				}
			}
			const path = feedCardActn[1]?._id;
			const res = from === 'events'
				? await getEventComments(query) // get event comments
				: await getComments(path, query); // get feed comments

			if (res?.status)
			{
				if (page === 0)
				{
					// res?.response?.length >= commentsPerPage
					// ? 
					getCmmntsCount(query);
					// : handleFeedAction('append', 'comments_add', from === 'events' ? res?.data?.length : res?.response?.length);
					setCommntsData(from === 'events' ? res?.data : res?.response);
				}
				else
				{
					setCommntsData([ ...commntsData, ...((from === 'events' ? res?.data : res?.response) || []) ]);
				}
			}
			else
			{
				setCommntsData(commntsData ?? []);
				// setCmmntsCount(cmmntsCount ?? 0);
				handleFeedAction('append', 'comments_add', 0);
			}
			loaderRef.current = res?.response?.length === 0;
		}
		catch (err)
		{
			console.log('---------------', err);
			loaderRef.current = true;

			catchErr(err);
		}
		finally
		{
			setLoading(false);
			// loaderRef.current = false;
		}
	};

	// Set Payload to update comments
	const generateBody = (url) =>
	{
		let body;

		if ([ 'reply' ]?.includes(actionKeys[0]))
		{
			body = {
				comment          : url !== 'comment' ? url : comment,
				replyToCommentId : from === 'events' ? actionKeys[1]?.commentId : actionKeys[1]?._id,
				replyName        : actionKeys[1]?.userData?.firstName,
				...(from === 'events' ? { eventId: selEvent?.eventId } : {})

			};

			if (from !== 'events')
			{
				body = {
					...body,
					feedId   : feedCardActn[1]?._id,
					refId    : generateRandomUUID(),
					userData : { firstName: userFullName(userData) }
				};
			}
		}
		else if (from === 'events')
		{
			body = {
				eventId  : selEvent?.eventId,
				userData : { firstName: userFullName(userData) },
				comment
			};
		}
		else
		{
			body = {
				feedId   : feedCardActn[1]?._id,
				refId    : generateRandomUUID(),
				comment  : url !== 'comment' ? url : comment,
				userData : { firstName: userFullName(userData) }
			};
		}

		return body;
	};

	// POST comments
	const handlePostComment = async (emojiUrl) =>
	{
		if (!loading)
		{
			if ((emojiUrl !== 'comment' && emojiUrl === '') || (emojiUrl === 'comment' && comment === ''))
			{
				// toast.error(language.enterTheComment, {
				// 	position : toast.POSITION.TOP_RIGHT
				// });

				return;
			}
			try
			{
				setLoading(true);
				const query:any = {
					uid     : userData?.userId,
					comid   : userData?.companyId,
					empRole : userData?.empRole,
					role    : userData?.role

				};
				const body = generateBody(emojiUrl);

				const res = from === 'events'
					? await createEventComments(body, query) // post event calling
					: await createComment(body, query); // post feed calling

				if (res?.status)
				{
					if ([ 'reply' ]?.includes(actionKeys[0]))
					{
						const updateData = [ ...commntsData ];
						const findInd = commntsData?.findIndex((cmnt) => cmnt?._id === actionKeys[1]?._id);

						updateData[findInd] = { ...updateData[findInd], repliesCount: (updateData[findInd]?.repliesCount || 0) + 1 };
						setCommntsData(updateData);
						setCallApi(!callApi);
					}
					else
					{
						const newComment = { ...res?.response };

						setCommntsData((prev) => [ newComment, ...prev || [] ]);
					}
					handleFeedAction('append', 'comments_add', (cmmntsCount + 1));
				}
				else
				{
					setCommntsData(commntsData || []);
				}
			}
			catch (err)
			{
				console.log(err);

				catchErr(err);
			}
			finally
			{
				setLoading(false);
				setComment('');
				showPicker !== '' && setShowPicker('');
				setAction({});
			}
		}
	};

	// Update comments
	const updateComment = async (emojiUrl) =>
	{
		try
		{
			setLoading(true);
			const query:any = {
				uid     : userData?.userId,
				comid   : userData?.companyId,
				empRole : userData?.empRole,
				role    : userData?.role

			};
			const body = {
				comment   : emojiUrl !== 'comment' ? emojiUrl : comment,
				commentId : from === 'events' ? actionKeys[1]?.commentId : actionKeys[1]?._id,
				...(from !== 'events' ? { feedId: feedCardActn[1]?._id } : {}),
				...(from === 'events' ? { eventId: selEvent?.eventId } : {})
			};

			const res = from === 'events'
				? await updateEventComment(body, query) // update event calling
				: await updateCommentApi(body, query); // update feed calling

			if (res?.status)
			{
				const updteIndex = commntsData?.findIndex((itemD:any) => itemD._id === actionKeys[1]?._id);

				const updatedViewData = [ ...commntsData ];

				updatedViewData[updteIndex] = { ...updatedViewData[updteIndex], comment: body?.comment };

				setCommntsData(updatedViewData);
			}
			else
			{
				setCommntsData(commntsData || []);
			}
		}
		catch (err)
		{
			console.log(err);
			catchErr(err);
		}
		finally
		{
			setLoading(false);
			setComment('');
			setAction({});
			showPicker !== '' && setShowPicker('');
		}
	};

	// Pagination side effects
	useEffect(() =>
	{
		LoadMoreList();
	}, [ lastEleRef, cmmntsCount, commntsData ]);

	// Get comment list side effect
	useEffect(() =>
	{
		if ((Array.isArray(feedCardActn) && feedCardActn?.length > 0 && feedCardActn[0] === 'comments') || from === 'events')
		{
			getCommentsList();
		}
	}, [ feedCardActn[1]?._id, page, selEvent ]);

	// const isMobileSM = useMediaQuery((theme: Theme) => theme.breakpoints.down(1370));

	// Close handler
	const handleCloseChat = () =>
	{
		openComment
			? setOpenComment((prev) => ({ ...prev, openComment: false }))
			: setFeedCardActn([]);
		handleFeedAction('append', 'comments_add', 0);
	};

	// Emoji handler
	const onEmojiClick = (emojiData, event:any) =>
	{
		event.stopPropagation();
		setComment((prevInput) => prevInput + emojiData.emoji);
	};

	// Emoji and Gif handler
	const handleChange = (typeD) =>
	{
		setShowPicker(typeD === showPicker ? '' : typeD);
	};

	// Gif handler
	const handleEmoji = (gifD) =>
	{
		actionKeys[0] === 'edit' ? updateComment(gifD?.url) : handlePostComment(gifD?.url);
	};

	// Context values
	const contextValues = useMemo(() =>
	{
		return {
			callApi,
			setCallApi,
			action,
			setAction
		};
	}, [ callApi, setCallApi, action, setAction ]);

	// user profile pic
	const avatarUrl = useMemo(() =>
	{
		const userId = Object?.keys(actionKeys)?.length > 0 ? (actionKeys[1]?.userData?.userId || actionKeys[1]?.userId) : userData?.userId;

		return userId ? `${process.env.REACT_APP_S3_BASE_URL}/profile/${userId}_profile.jpeg` : '/images/icons/defaultUser.svg';
	}, [ actionKeys, userData ]);

	useEffect(() =>
	{
		if (autoFocusRef?.current)
		{
			autoFocusRef.current.focus();
		}
	}, [ actionKeys ]);

	return (
		<commentContext.Provider value={contextValues}>
			<Grid item xs={12} height='var(--percent100)'>
				{/* {loading && <CommentShimmer />} */}
				<Box bgcolor='var(--whiteColor)' border={openComment ? '' : '1px solid rgba(0, 0, 0, 0.12)'} borderRadius={3.5} padding={openComment ? '12px 0px' : ' 12px 8px'} width={'var(--percent100)'} height={commntsData?.length === 0 ? 'var(--percent100)' : undefined} display='flex' justifyContent='space-between' flexDirection='column' minHeight='var(--percent100)'>
					<Stack direction='column' height='var(--percent100)'>
						<Stack direction='row' justifyContent='space-between' alignItems='start' px='var(--pixel8)'>
							{/* when we scroll that time we need company name  */}
							{openComment
								?	<Typography variant='inherit' fontWeight='var(--font500)'>{language?.comments} ({cmmntsCount})</Typography>
								:	type !== 'celebrationevents' && <Stack direction='row' spacing={1} alignItems='center'maxWidth='90%'>
									<Box display='inline-flex' height={28} width={28} sx={{ flexShrink: 0 }}>
										<ProfilePic /** company logo */
											imagePath={`${feedCardActn[1]?.createdBy}_${[ 'employee', 'individual' ].includes(feedCardActn[1]?.userData?.role) ? 'profile' : 'logo'}.jpeg?t=${new Date().valueOf()}`}
											defaultImg={('/images/icons/defaultUser.svg')}
											alt='createdBy'
											className='brdrRadius50 pointer objectFitCover'
										/>
									</Box>
									<Stack direction='column' alignItems='start' spacing={0.2} sx={{ minWidth: '100%' }}>
										<Typography
											variant='subtitle1'
											fontWeight='var(--font500)'
											sx={{
												whiteSpace   : 'nowrap',
												overflow     : 'hidden',
												textOverflow : 'ellipsis',
												lineHeight   : 1.2,
												maxWidth     : '80%'
											}}
										>
											{/* {feedCardActn[1]?.userData?.role === 'company'
												? feedCardActn[1]?.userData?.companyName
												: feedCardActn[1]?.userData?.fullName} */}
											<Typography variant='inherit' fontWeight='var(--font500)'>{language?.comments} ({cmmntsCount})</Typography>
										</Typography>
										<Typography fontSize='var(--pixel12)' fontWeight='var(--font500)' color='var(--txtColorBlackL)'>
											{DateDiff(feedCardActn[1]?.postedAt, new Date().valueOf())}

										</Typography>
									</Stack>
								</Stack>
							}
							{openComment
								? <Box component='span'>
									<FaAngleUp fontSize='var(--pixel20)' color='#536471' style={{ cursor: 'pointer' }} onClick={() => { handleCloseChat(); }}/>
								</Box>
								: type !== 'celebrationevents' && <RxCross2 fontSize='var(--pixel20)' color='var(--black)' style={{ cursor: 'pointer' }} onClick={() => { handleCloseChat(); }}/>
							}
						</Stack>
						{/* chat part */}
						{commntsData?.length > 0 &&
						commntsData?.map((cmntData:any, index:any) =>
							(
								<>
									<IndividualCmnt
										key={cmntData?._id ?? cmntData?.id ?? generateRandomUUID()}
										cmntData={cmntData}
										index={index}
										commntsData={commntsData}
										setCommntsData={setCommntsData}
										from={from}
										selEvent={selEvent}
										handleUpdate={(cmnt) => setComment(cmnt)}
									/>
									{index === commntsData?.length - 1 && <span ref={lastEleRef}/>}
								</>
							))
						}
						{commntsData?.length === 0 &&
						<div className='flexCol pdngXS justifyCntr fullHeight'>
							<NoData noDataHead={language?.noCmmnts} color='lightTxt' src1='/images/Bpsnodata.svg' />
						</div>
						}
					</Stack>
					{/* chat footer */}
					<div id='show-cmntReply-btn'/>
					{![ 'cmntReply', 'cmntEdit' ]?.includes(actionKeys[0]) &&
					<Stack direction='column' spacing={0.75} sx={{ position: 'sticky', bottom: '-8px', left: '0', background: 'var(--whiteColor)' }}>
						{!openComment &&
						<Stack direction='row' spacing={1} position='relative' alignItems='center'>
							<MdOutlineGif fontSize={26} style={{ cursor: 'pointer' }} onClick={() => handleChange('gif')} color={showPicker === 'gif' ? '#23A4C4' : ''}/>
							<CgSmileMouthOpen fontSize='var(--pixel20)' style={{ cursor: 'pointer' }} onClick={() => handleChange('emoji')} color={showPicker === 'emoji' ? '#23A4C4' : ''}/>
							<Box position='absolute' bottom={24} maxHeight='var(--font320)' left='0px' zIndex={999} overflow='auto' width='var(--percent100)' ml='0px !important'>
								{showPicker === 'emoji' &&
								<EmojiPicker emojiStyle={EmojiStyle.GOOGLE}
									height={320}
									onEmojiClick={onEmojiClick}
									width='var(--percent100)'
									previewConfig={{ showPreview: false }} autoFocusSearch={false}
								/>}
							</Box>
							<Box position='absolute' bottom={24} width='var(--percent100)' left='-8px' zIndex={999} overflow='auto'>

								{showPicker === 'gif' &&
								<GifPickerWrapper handleEmoji={handleEmoji}/>
								}
							</Box>
						</Stack>}

						{
							Object?.keys(action)?.length > 0 && [ 'reply', 'edit' ]?.includes(actionKeys[0]) &&
							<Box sx={{ background: '#E1E1E1' }} p='var(--pixel8)' borderRadius={2}>
								<Stack direction='row' justifyContent='space-between' alignItems='center'>
									<Typography variant='caption'>{actionKeys[0] === 'edit' ? `${language?.edit} ` : `${language?.replyTo} `}
										<Typography variant='caption' component='span' fontWeight={500}>
											<Typography variant='caption' component='span' fontWeight={500}>
												{`${actionKeys[1]?.userData?.firstName}'s ${language.comment}`}
											</Typography>
										</Typography>
									</Typography>
									<RxCross2 fontSize='var(--pixel18)' color='var(--black)' style={{ cursor: 'pointer' }} onClick={() => setAction({})}/>
								</Stack>
							</Box>
						}

						<Box sx={{ background: '#F0F0F3' }} p='var(--pixel12)' borderRadius={2}>
							<Stack direction='row' justifyContent='space-between'>
								<Stack direction='row' spacing={1} alignItems='center' width='var(--percent100)'>
									{/* <Avatar
										sx={{ width: 24, height: 24, border: '1px solid #E6E4EA' }}
										alt='event_profile_pic'
										src={avatarUrl}
									/> */}
									<Box display='inline-flex'
										height={24}
										width={24}
										alignItems='center'
										justifyContent='center'
									>

										<ProfilePic
											imagePath={avatarUrl}
											defaultImg='/images/icons/defaultUser.svg'
											loadUrl='profile'
											alt='createdBy_img'
											className='brdrRadius50'
										/>
									</Box>
									<TextField
										size='small'
										fullWidth
										id='msgField'
										variant='outlined'
										value={comment}
										style={{ border: 'none' }}
										placeholder={language?.addaComment}
										onChange={(e) => setComment(e?.target?.value?.replace(/^\s+/, ''))}
										onFocus={focus}
										autoFocus={false}
										inputRef={autoFocusRef}
										// disabled={loading}
										onKeyDown={(e) =>
										{
											if (e.key === 'Enter')
											{
												e.preventDefault();
												if (comment.trim())
												{
													actionKeys[0] === 'edit' ? updateComment('comment') : handlePostComment('comment');
												}
											}
										}}
										InputProps={{
											sx : {
												'& .MuiOutlinedInput-notchedOutline' : {
													border : 'none'
												},
												'&:hover .MuiOutlinedInput-notchedOutline' : {
													border : 'none'
												},
												'&.Mui-focused .MuiOutlinedInput-notchedOutline' : {
													border : 'none'

												}
											},

											inputProps : {
												sx : {
													padding : '0 14px 0 0 '
												}
											}
										}}
									/>
								</Stack>
								<VscSend fontSize='var(--pixel24)' color={comment.trim() ? 'var(--primaryColor)' : '#CCCCCC'} style={{ cursor: comment.trim() ? 'pointer' : 'not-allowed', opacity: comment.trim() ? 1 : 0.5 }}
									onClick={() =>
									{
										if (comment.trim())
										{
											actionKeys[0] === 'edit' ? updateComment('comment') : handlePostComment('comment');
										}
									}}
								/>
							</Stack>
						</Box>
					</Stack>
					}

				</Box>
			</Grid>
		</commentContext.Provider>
	);
};

export default Comments;
